import {
  Backdrop,
  CircularProgress,
  Modal,
  Popper,
  Portal,
} from "@mui/material";
import { usePortal } from "../../hooks/usePortal";
import { blue } from "@mui/material/colors";

export default function LoadingPortal({ children }) {
  const { open } = usePortal();

  return (
    <>
      {children}

      <Backdrop
        sx={(theme) => ({
          // marginTop: "60px",
          // backgroundColor: "transparent",
          color: "#000000",
          zIndex: theme.zIndex.drawer + 1,
          height: `${window.innerHeight}`,
        })}
        open={open}>
        <CircularProgress
          sx={{
            width: "50px !important",
            height: "50px !important",
            color: blue[900],
          }}
        />
      </Backdrop>
    </>
  );
}
